// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Jura, sans-serif',
    allVariants: {
      fontFamily: 'Jura, sans-serif'
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Jura, sans-serif'
        }
      }
    }
  }
});

export default theme;
